import { Component, ChangeDetectionStrategy, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { FirestoreRulesService } from 'src/app/core/firestore-rules/firestore-rules.service';

@Component({
  selector: 'cell-actions-users-roles',
  templateUrl: './cell-actions-users-roles.component.html',
  styleUrls: ['./cell-actions-users-roles.component.scss'],
})
export class CellActionsUsersRolesComponent implements ICellRendererAngularComp, OnInit {
  refresh;
  isAdminMark: boolean;
  private params: any;
  constructor(private readonly translate: TranslateService,
              private readonly firestoreRulesService: FirestoreRulesService) {}

  ngOnInit(): void {
    const isAdmin = this.firestoreRulesService.getisUserAdmin(this.params.data.metadata.docId)
    .then((isAdminRes) => {
      this.isAdminMark = isAdminRes as boolean;
    })
    .catch((error) => {
      console.error(error);
    });
  }

  agInit(params: ICellRendererParams): void {
    this.params = params;
  }

  getAdminDisplay(): string {
    return this.translate.instant('RESOURCE_LIST.USERS_TABLE.ADMIN');
  }

  getUserDisplay(): string {
    return this.translate.instant('RESOURCE_LIST.USERS_TABLE.USER');
  }
}
